// extracted by mini-css-extract-plugin
export default {"markdown":"markdown-elements_markdown__BTppp"};